import React from 'react';
import { AlertTriangle, Clock, Frown, MessageSquareOff, Smartphone, Volume2 } from 'lucide-react';
import { Button } from './ui/Button';
export function ProblemSection() {
  return <section className="bg-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-211">
      <div className="max-w-5xl mx-auto" data-id="element-212">
        {/* Hook */}
        <div className="text-center mb-12" data-id="element-213">
          <h2 className="text-2xl md:text-3xl font-bold text-[#1e3a5a] mb-4" data-id="element-214">
            ¿Terminás las clases sintiendo que hablaste solo?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-215">
            El problema no sos vos.{' '}
            <strong className="text-[#1e3a5a]" data-id="element-216">
              Es que Política y Ciudadanía no está pensada para el aula real.
            </strong>
          </p>
        </div>

        {/* Visual Problems Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-12" data-id="element-217">
          <div className="bg-red-50 p-5 rounded-xl text-center border border-red-100 transform transition hover:scale-105" data-id="element-218">
            <MessageSquareOff className="w-8 h-8 text-red-500 mx-auto mb-2" data-id="element-219" />
            <p className="font-semibold text-gray-800 text-sm" data-id="element-220">Textos largos</p>
          </div>
          <div className="bg-red-50 p-5 rounded-xl text-center border border-red-100 transform transition hover:scale-105" data-id="element-221">
            <AlertTriangle className="w-8 h-8 text-red-500 mx-auto mb-2" data-id="element-222" />
            <p className="font-semibold text-gray-800 text-sm" data-id="element-223">
              Conceptos abstractos
            </p>
          </div>
          <div className="bg-red-50 p-5 rounded-xl text-center border border-red-100 transform transition hover:scale-105" data-id="element-224">
            <Frown className="w-8 h-8 text-red-500 mx-auto mb-2" data-id="element-225" />
            <p className="font-semibold text-gray-800 text-sm" data-id="element-226">No conecta</p>
          </div>
          <div className="bg-red-50 p-5 rounded-xl text-center border border-red-100 transform transition hover:scale-105" data-id="element-227">
            <Smartphone className="w-8 h-8 text-red-500 mx-auto mb-2" data-id="element-228" />
            <p className="font-semibold text-gray-800 text-sm" data-id="element-229">Celulares</p>
          </div>
          <div className="bg-red-50 p-5 rounded-xl text-center border border-red-100 transform transition hover:scale-105" data-id="element-230">
            <Volume2 className="w-8 h-8 text-red-500 mx-auto mb-2" data-id="element-231" />
            <p className="font-semibold text-gray-800 text-sm" data-id="element-232">
              Silencios incómodos
            </p>
          </div>
          <div className="bg-red-50 p-5 rounded-xl text-center border border-red-100 transform transition hover:scale-105" data-id="element-233">
            <Clock className="w-8 h-8 text-red-500 mx-auto mb-2" data-id="element-234" />
            <p className="font-semibold text-gray-800 text-sm" data-id="element-235">
              Horas planificando
            </p>
          </div>
        </div>

        {/* Key Message */}
        <div className="bg-[#1e3a5a] text-white p-8 rounded-2xl shadow-xl text-center" data-id="element-236">
          <h3 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-237">
            El problema no es la materia.{' '}
            <span className="text-[#d4a853]" data-id="element-238">Es cómo se da.</span>
          </h3>
          <p className="text-blue-100 mb-6 max-w-2xl mx-auto" data-id="element-239">
            Buscar material, adaptar textos, pensar actividades... semana tras
            semana. Y lo peor es sentir que la materia no pesa, no se valora, no
            se disfruta.
          </p>
          <Button className="text-lg px-8 py-4" data-id="element-240">QUIERO LA SOLUCIÓN</Button>
        </div>
      </div>
    </section>;
}